import React from 'react';
import { Home, ChevronRight } from 'lucide-react';
import { Category } from '../types/invoices';
import { monthLabel } from '../utils/invoices';

interface Props {
  category: Category | null;
  year: string | null;
  month: string | null;
  onRoot: () => void;
  onCategory: (c: Category) => void;
  onYear: (y: string) => void;
}

const Breadcrumbs: React.FC<Props> = ({
  category,
  year,
  month,
  onRoot,
  onCategory,
  onYear,
}) => (
  <div className="flex items-center gap-2 text-sm text-neutral-600">
    <button
      onClick={onRoot}
      className="inline-flex items-center gap-1 hover:underline"
      aria-label="Racine"
    >
      <Home className="w-4 h-4" />
      <span>Factures</span>
    </button>
    {category && (
      <>
        <ChevronRight className="w-4 h-4" />
        <button
          onClick={() => onCategory(category)}
          className="capitalize hover:underline"
        >
          {category}
        </button>
      </>
    )}
    {year && (
      <>
        <ChevronRight className="w-4 h-4" />
        <button onClick={() => onYear(year)} className="hover:underline">
          {year}
        </button>
      </>
    )}
    {month && (
      <>
        <ChevronRight className="w-4 h-4" />
        <span className="capitalize">{monthLabel(month)}</span>
      </>
    )}
  </div>
);

export default Breadcrumbs;
